import { DropdownMenu, Text, Flex } from '@scale/scaleui-radix';
import { routeForUser } from 'react-scale/corp/views/CorpProjectGroupManager/apps/Allocation/constants/nav';
import { useHistory } from 'react-router-dom';

type ProfileMenuProps = {
  firstName: string;
  lastName: string;
  email: string;
  userId: string;
  handleLogoutClick: () => void;
};

export const OpsHubProfileMenu = ({
  firstName,
  lastName,
  email,
  userId,
  handleLogoutClick,
}: ProfileMenuProps) => {
  const initials = firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : 'U';
  const history = useHistory();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <button className="flex flex-col justify-center items-center w-[40px] h-[40px] !bg-[#0037B613] rounded-full gap-2 text-[16px] leading-[24px] font-medium text-[rgba(0,0,0,0.61)] tracking-[0px] min-w-[40px] min-h-[40px]">
          {initials}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content color="neutral" variant="soft" className="w-[280px] p-6" size="2">
        {/* User Info Section */}
        <DropdownMenu.Label className="h-[48px]">
          <Flex direction="column" gap="1" className="px-2 py-5 border-b border-neutral-200 !pr-8">
            <Text size="2" weight="medium">
              {firstName} {lastName}
            </Text>
            <Text size="1">{email}</Text>
          </Flex>
        </DropdownMenu.Label>

        <DropdownMenu.Separator />

        {/* Menu Items */}
        <DropdownMenu.Item
          onClick={() => history.push(routeForUser(userId))}
          className="flex flex-row items-center px-2 h-[32px] gap-2 bg-white rounded hover:bg-neutral-100"
        >
          <Flex gap="3" align="center" className="w-full">
            <Text>Profile</Text>
          </Flex>
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onClick={handleLogoutClick}
          className="flex flex-row items-center px-2 h-[32px] gap-2 bg-white rounded hover:bg-neutral-100"
        >
          <Flex gap="3" align="center" className="w-full">
            <Text>Logout</Text>
          </Flex>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
